define('rebrush/components/product/view/related-link-in-description',[
    'jquery',
    'lodash',
    'cartware/components/_base',
    'cartware/jquery/bem',
    'cartware/components/Holepunch'
], function(
    $,
    _,
    Component,
    BEM,
    holepunch
) {
    var PRODUCT_VIEW_BLOCK = 'product-view';

    return Component.create({
        constructor: function() {
        },

        $init: function() {
            $(document).on('product/changeSimple', $.proxy(_onSimpleChange, this));
            this.hub.on('product/changeSimple', $.proxy(_onSimpleChangeCallback, this));
            holepunch.ready($.proxy(function(payload) {
                _.forEach(payload.blocks || [], function (block, key) {
                    if ('product_info_related_holepunch' === key) {
                        var currentSimple = _.get(window, 'spConfig.__currentSimple');
                        addAccessoriesLink({}, currentSimple);
                    }
                });
            }, this));
            function _onSimpleChangeCallback(simple) {
                _onSimpleChange({}, simple);
            }
            function _onSimpleChange(e, simple) {
                addAccessoriesLink({}, simple);
            }
            function addAccessoriesLink(e, simple) {
                if ($('.' + BEM.buildBlockClassname('product-related')).length) {
                    if ($('.' + BEM.buildElementClassname(PRODUCT_VIEW_BLOCK, 'short-description > ul > li')).length) {
                        if (window._etracker && simple && simple.product_name != null) {
                            var $append = '<li><a onclick="_etracker.sendEvent(new et_ClickEvent(\'Beschreibung Zubehoer\',\'' + simple.product_name + '\')); ' +
                                'return false;" href="#product_info_related_holepunch">' + Translator.translate('To product accessories') + '</a></li>';
                        } else {
                            var $append = '<li><a href="#product_info_related_holepunch">' + Translator.translate('To product accessories') + '</a></li>';
                        }
                        $('.' + BEM.buildElementClassname(PRODUCT_VIEW_BLOCK, 'short-description > ul'))
                            .append($append);
                        return;
                    } else {
                        if (window._etracker && simple && simple.product_name != null) {
                            var $append = '<a onclick="_etracker.sendEvent(new et_ClickEvent(\'Beschreibung Zubehoer\',\'' + simple.product_name + '\')); ' +
                                'return false;" href="#related-products">' + payload.block_titles[key] + '</a>';
                        } else {
                            var $append = '<a href="#related-products">' + payload.block_titles[key] + '</a>';
                        }
                        $('.' + BEM.buildElementClassname(PRODUCT_VIEW_BLOCK, 'short-description'))
                            .after($append);
                        return;
                    }
                }
            }
        }
    });
});
